export default {
  channel_feed_title: 'Channel Feed',
  mark_all_as_read_button: 'Mark As Read',
  view_all_message_button: 'View all Messages',
  channel_feed_empty_text: "You're all done!",
};
